<template>
  <div class="vx-row mb-2 -mt-1 dropDown" v-if="showDataField">
    <div class="vx-col" :class="calculateSize">
      <span class="text-xs">{{ structure.label }}</span>
      <v-select
        class="w-full"
        :label-placeholder="structure.label"
        name="field"
        v-validate="structure.validation"
        v-model="selected"
        :appendToBody="appendToBody"
        :options="structure.data"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
      />
      <span class="text-danger text-sm" v-show="errors.has('field')">{{
        errors.first("field")
      }}</span>
    </div>
  </div>
</template> 
<script>

// :appendToBody="appendToBody"

import vSelect from "vue-select";
import { helperMixin } from "../../../mixin/helperMixin";
import { sidebarMixin } from "../sidebarMixin";
import { bus } from "../../../main";
export default {
  mixins: [helperMixin, sidebarMixin],
  components: {
    vSelect,
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String, // change from Number to String because of PR branch
    validation: "",
    size: String,
    appendToBody: {
      type: Boolean,
      defaul: false,
    },
  },
  data() {
    return {
      selected: this.thevalue,
      tempArray: [],
      currentValueOfShowHideField: true, //this is to retain the current value of show and hide 
    };
  },
  computed: {
    thevalue() {
      return this.value != null ? JSON.parse(this.value).id : "";
    },
    calculateSize() {
      return this.size == undefined ? "w-full" : this.size;
    },
    showDataField() {
      return this.showField();
    },
  },
  created() {
    console.log("value:", this.value);
    if (this.value != undefined && this.value != "") {
      this.selected = this.arrayOfObjectFind(
        this.structure.data,
        this.value
      )[0];
    }

    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    //if local value is undefined we apply the default value found in structure
    if (this.value == undefined) {
      this.localVal = this.structure.value; //assigning the default value

      //if value is undefined and it is required we return false otherwise true
      if (this.structure.required == "yes") {
        if (this.localVal == "" || this.localVal == undefined) {
          this.$emit("error", { index: this.index, value: false });
        } else {
          this.$emit("error", { index: this.index, value: true });
        }
      } else {
        this.$emit("error", { index: this.index, value: true });
      }

      this.$emit("input", {
        index: this.index,
        value: this.structure.value,
      });
    }

    //event bus for hiding and showing field based on other field
    bus.$emit("showHideField", {
      index: this.index,
      value: this.structure.value,
    });

    this.$watch("selected", (value) => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
        value = value.id;
      }

      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", { index: this.index, value: value });
    });
  },
};
</script>

<style lang="scss" scoped>
.dropDown {
}
</style>